import { get, post, remove, put } from "./api";

export async function createLink(newLink: any) {
  const { data } = await post({ path: `/item-links`, data: newLink });
  return data;
}

export async function importJiraIssue(issueKey: string) {
  const { data } = await put({
    path: `/item-links/jira/issues/${issueKey}/import`,
  });
  return data;
}

export async function deleteLink(linkId: any) {
  const { data } = await remove({ path: `/item-links/${linkId}` });
  return data;
}

export async function searchByObjectId(sourceObjectId: string) {
  const { data } = await get({
    path: `/item-links/search?objectId=${sourceObjectId}`,
  });
  return data;
}

export async function getItemLinksByTarget(targetObjectId: string) {
  const { data } = await get({
    path: `/item-links/target?targetObjectId=${targetObjectId}`,
  });
  return data;
}

export async function detectCustomers(
  issueKey: string,
  _issueContent: {
    summary?: string;
    description?: string;
    comments?: string[];
    reporter?: string;
  }
) {
  const { data } = await post({
    path: `/jira/issues/${issueKey}/detect-customers`,
    data: {},
  });
  return data;
}
